import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
//import { GatsbyImage } from 'gatsby-plugin-image'

const FeatureProducts = () => {
  const data = useStaticQuery(
    graphql`
      {
        allWpPost(
          filter: {
            categories: { nodes: { elemMatch: { name: { eq: "featured" } } } }
          }
        ) {
          nodes {
            id
            title
            excerpt
            uri
            featuredImage {
              node {
                sourceUrl
                srcSet
                altText
              }
            }
          }
        }
      }
    `
  )

  const { allWpPost } = data

  return (
    <div className='featured-container my-5'>
      <h1 className='text-center'>PRODUCTOS DESTACADOS</h1>

      <p className='col-11 col-md-8 text-center'>
        Los extintores portátiles de mano Amerex tienen una línea completa tanto
        del tipo de "cumplimiento" <i>(código requerido)</i> así como de
        "especialidad" que funcionan para incendios de materiales específicos.
      </p>
      {/* {<pre>{JSON.stringify(data, null, 4)}</pre>} */}
      {/* product cards */}
      <div className='card-group col-12 col-md-10'>
        {allWpPost.nodes.map(({ id, title, excerpt, featuredImage, uri }) => (
          <div key={id} className='card bg-white border-white'>
            <img
              className='card-img-top p-3 img-fluid'
              width='264px'
              src={featuredImage.node.sourceUrl}
              srcSet={featuredImage.node.srcSet}
              alt={featuredImage.node.altText}
            />
            {/* <pre>{JSON.stringify(featuredImage.node.srcSet)}</pre> */}
            {/* <GatsbyImage
              image={
                featuredImage.node.localFile.childImageSharp.gatsbyImageData
              }
              alt={featuredImage.node.altText}
            /> */}
            <div className='card-body'>
              <p className='card-title text-uppercase text-center fw-bold lead fs-6 m-0'>
                {title}
              </p>
              <p className='card-text text-center ellipsis'>
                {excerpt.replace(/(<([^>]+)>)/gi, ' ')}
              </p>
              <div className='d-grid gap-2'>
                <Link className='btn btn-danger fs-6' type='button' to={uri}>
                  Ver detalles
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FeatureProducts
